<template>
    <v-container>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
export default {    
    name: "LoadingOverlay",
    props: {
        isLoading: Boolean
    },
    data() {
        return {
            loading : false,
        }
    },
    created() {
        console.log("yo LoadingOverlay");
    }
}
</script>

<style scoped>

</style>